export default __webpack_public_path__ + "static/media/kickbox.4c4a1953.jpg";